import axiosInstance from "../../axiosInstance";

const BASE_URL = "/finance/invoices";

export const getAllInvoices = async (params = {}) => {
  const res = await axiosInstance.get(BASE_URL, { params });
  return res.data;
};

export const getInvoiceDetail = async (id) => {
  const res = await axiosInstance.get(`${BASE_URL}/${id}`);
  return res.data;
};

export const createInvoice = async (payload) => {
  const isFormData =
    typeof FormData !== "undefined" && payload instanceof FormData;
  const res = await axiosInstance.post(BASE_URL, payload, {
    headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
    timeout: isFormData ? 120_000 : 30_000,
  });
  return res.data;
};

export const updateInvoice = async (id, payload) => {
  const isFormData =
    typeof FormData !== "undefined" && payload instanceof FormData;
  const res = await axiosInstance.put(`${BASE_URL}/${id}`, payload, {
    headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
    timeout: isFormData ? 120_000 : 30_000,
  });
  return res.data;
};

export const updateInvoiceStatus = async (id, payload) => {
  const res = await axiosInstance.patch(`${BASE_URL}/${id}/status`, payload);
  return res.data;
};

export const deleteInvoice = async (id) => {
  const res = await axiosInstance.delete(`${BASE_URL}/${id}`);
  return res.data;
};

export const INVOICE_TYPE_OPTIONS = [
  { value: "purchase", label: "Hóa đơn mua" },
  { value: "sale", label: "Hóa đơn bán" },
];

export const PURCHASE_STATUS_OPTIONS = [
  { value: "pending", label: "Chưa xử lý" },
  { value: "recorded", label: "Đã ghi sổ" },
  { value: "payment_requested", label: "Đã tạo ĐN thanh toán" },
  { value: "paid", label: "Đã thanh toán" },
  { value: "completed", label: "Hoàn tất" },
];

export const SALE_STATUS_OPTIONS = [
  { value: "issued", label: "Đã xuất (bên ngoài)" },
  { value: "recorded", label: "Đã ghi nhận" },
  { value: "receipt_linked", label: "Đã liên kết phiếu thu" },
  { value: "completed", label: "Hoàn tất" },
];

export const getStatusOptions = (invoiceType) =>
  invoiceType === "sale" ? SALE_STATUS_OPTIONS : PURCHASE_STATUS_OPTIONS;

export const getStatusLabel = (invoiceType, status) => {
  const options = getStatusOptions(invoiceType);
  return options.find((o) => o.value === status)?.label || status || "—";
};
